<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';
import { useScriptTag } from '@vueuse/core'

@Component({})
export default class EmbeddedSignup extends Vue {
  private loading = false;
  private created() {
    this.loading = true;
  }
  private async mounted() {
    const { load } = useScriptTag(
        'https://js.hsforms.net/forms/embed/5099377.js',
        (el: HTMLScriptElement) => {
          setTimeout(() => {
            this.loading = false;
          }, 300)
        },
        { manual: true }
    );
    await load();
  }
}
</script>

<template>
  <div class="fill-height overflow-x-hidden">
    <v-row style="height: calc(100% - 48px)">
      <v-col cols="12">
        <v-row class="fill-height pa-4" justify="center" align="center">
          <v-col cols="5">
            <v-card border="primary md" flat min-height="330">
              <v-row justify="center" align="center" v-if="loading" style="height: 330px">
                <v-col cols="auto">
                  <v-progress-circular color="primary" :indeterminate="loading"></v-progress-circular>
                </v-col>
              </v-row>
              <div v-else class="hs-form-frame" data-region="na1" data-form-id="999801d4-f7fd-4a24-80c2-c8dfcb7e9b87" data-portal-id="5099377"></div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>

</style>